export const normalizeTextForImport = (value = '') => String(value || '')
  .toLowerCase()
  .replace(/https?:\/\/\S+/g, ' ')
  .replace(/[^a-z0-9]+/g, ' ')
  .replace(/\s+/g, ' ')
  .trim();

export const splitIntoSentences = (text = '') => String(text || '')
  .trim()
  .split(/(?<=[.!?])\s+(?=[A-Z0-9"“(])/u)
  .map((sentence) => sentence.trim())
  .filter(Boolean);

export const normalizeParsedImportText = (text = '') => String(text || '')
  .replace(/\(\s*\)/g, ' ')
  .replace(/\s+,/g, ',')
  .replace(/,\s*,/g, ',')
  .replace(/\s{2,}/g, ' ')
  .replace(/\s+([.!?])/g, '$1')
  .trim();
